<template>
<div>
 <div role="tablist" class="accordian-css" v-show="educationStatus.isSSCPassed">
                <div role="tab col">
                    <div href="#" class="title-css" v-b-toggle.accordion1 variant="info">1. SSC
                        <span>Click to view</span>
                    </div>
                </div>
                <b-collapse id="accordion1" visible accordion="my-accordion" role="tabpanel">
                <ssc-details></ssc-details>
                </b-collapse>
 </div>
  <div role="tablist" class="accordian-css" v-show="educationStatus.isHSCPassed">
                <div role="tab col">
                    <div href="#" class="title-css" v-b-toggle.accordion2 variant="info">2. HSC
                        <span>Click to view</span>
                    </div>
                </div>
                <b-collapse id="accordion2" visible accordion="my-accordion" role="tabpanel">
                <hsc-details></hsc-details>
                </b-collapse>
 </div>
  <div role="tablist" class="accordian-css" v-show="educationStatus.isDiplomaPassed">
                <div role="tab col">
                    <div href="#" class="title-css" v-b-toggle.accordion3 variant="info">3. Diploma
                        <span>Click to view</span>
                    </div>
                </div>
                <b-collapse id="accordion3" visible accordion="my-accordion" role="tabpanel">
                <diploma-details></diploma-details>
                </b-collapse>
 </div>
 </div>
</template>
<script>
import sscDetails from './sscDetails.vue'
import hscDetails from './hscDetails.vue'
import diplomaDetails from './diplomaDetails.vue'
import axios from 'axios'
export default {
  name: 'EducationFieldDetails',
  components: {
    sscDetails,
    hscDetails,
    diplomaDetails
  },
  data () {
    return {
      educationStatus: {}
    }
  },
  methods: {
    getEducationDetails () {
      var self = this
      var profileUser = this.$store.state.candidateProfile.profileUser
      axios.get('r/candidateProfile/getQualificationDetails/' + profileUser)
            .then(function (response) {
              if (response.status === 200) {
                console.log('resp')
                self.educationStatus = response.data
                // self.certificationList.push(self.defaultObj)
              }
            })
            .catch(function () {
              self.$toasted.error('Error while featch education details', {
                theme: 'bubble',
                duration: 2000
              })
            })
    }
  },
  created: function () {
    this.getEducationDetails()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/registration/educationFieldDetails.vue